import {Injectable} from '@angular/core';
import {ApiUrlsEnum} from '@lib/enums';
import {IGoods, IGoodsSet, IPostSetDto, ISetGoodsQuery} from '@lib/interfaces';
import {httpParamsUtil} from '@lib/utils';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {FileTransferService} from './file-transfer.service';
import {map, switchMap} from "rxjs/operators";

@Injectable()
export class GoodsDataService extends FileTransferService {

  public getSets(filter: any): Observable<Array<IGoodsSet>> {
    const params = httpParamsUtil(filter);
    return this.http.get<Array<IGoodsSet>>(`${environment.host}${ApiUrlsEnum.promoSets}`, {params});
  }

  public createSet(set: IPostSetDto): Observable<IGoodsSet> {

    return this.http.post<IGoodsSet>(`${environment.host}${ApiUrlsEnum.promoSet}`, set);
  }

  public updateSet(set: IPostSetDto): Observable<IGoodsSet> {
    const params = httpParamsUtil({setId: set.id});

    return this.http.put<IGoodsSet>(`${environment.host}${ApiUrlsEnum.promoSet}`, set, {params});
  }

  public deleteSet(setId: number): Observable<void> {
    const params = httpParamsUtil({setId});
    return this.http.delete<void>(`${environment.host}${ApiUrlsEnum.promoSet}`, {params});
  }

  public getGoods(data: ISetGoodsQuery): Observable<Array<IGoods>> {
    const params = httpParamsUtil(data);

    return this.http.get<Array<IGoods>>(`${environment.host}${ApiUrlsEnum.promoSetGoods}`, {params});
  }

  public createGood(good: IGoods, setId: number): Observable<IGoods> {
    const params = httpParamsUtil({setId});

    const data = {
      name: good.name,
    };

    return this.http.post<IGoods>(`${environment.host}${ApiUrlsEnum.promoSet}`, data, {params});
  }

  public updateGood(good: IGoods, setId: number): Observable<IGoods> {
    const params = httpParamsUtil({setId});
    const data = {
      name: good.name,
    };

    return this.http.put<IGoods>(`${environment.host}${ApiUrlsEnum.promoGood}`, data, {params});
  }

  public deleteGood(goodId: number): Observable<void> {
    const params = httpParamsUtil({goodId});
    return this.http.delete<void>(`${environment.host}${ApiUrlsEnum.promoGood}`, {params});
  }

  public downloadSets(): Observable<{
    blob: Blob,
    fileName: string;
  }> {
    return this.http.get<{
      reportUrl: string,
      succeed: boolean
    }>(`${environment.host}${ApiUrlsEnum.downloadSets}`)
      .pipe(
        switchMap(response => this.http.get(response.reportUrl, {
            responseType: 'blob'
          }).pipe(map(blob => blob && {
            blob, fileName: response.reportUrl.match(/(?!\/\/).+\/(.+)$/)[1]
          }))
        )
      )
  }
}
